export default {
    productNumberList: [
        {
            title: "默认",
            list: [
                "1",
                "2",
                "3",
                "4",
            ]
        },
    ],
}